export default "__VITE_ASSET__CTUMl19m__"